import * as UH from './../util/UrlHttp'
import axios from 'axios'

export const GetLanguages = async () => {
    return await axios.get(`${UH.BASE_URL}languages/`, UH.HEADER_HTTP_TOKEN)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetLanguage = async (id: any) => {
    return await axios.get(`${UH.BASE_URL}languages/${id}`, UH.HEADER_HTTP_TOKEN)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
}

export const UpdateLanguageTexts = async (id: any, texts: any) => {
    return await axios.post(`${UH.BASE_URL}languages/${id}`, { texts }, UH.HEADER_HTTP_TOKEN)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
}
